export default "__VITE_ASSET__7b6225a3__"